module.exports = __webpack_public_path__ + "img/logo-bpseguradora.8ff6ed00.svg";